// extracted by mini-css-extract-plugin
export default {"ava":"Zxa7fk8ipKh29037Z6aX","icon":"JqIYnLtQCZLqwyifyAnf","activeSvg":"gVtd95mhz19z8QfvQGRZ","active":"dPXww2Tjwp_DBtC0gkaH","placeHolderShimmer":"ZefZBmI5ihhjeoMqgVSd"};